import { render, staticRenderFns } from "./ShopOrd.vue?vue&type=template&id=5be5871a&scoped=true&"
import script from "./ShopOrd.vue?vue&type=script&lang=js&"
export * from "./ShopOrd.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrd.vue?vue&type=style&index=0&id=5be5871a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be5871a",
  null
  
)

export default component.exports